import { useWorkStore } from '@/store/student/work_store';
import { convertLatex } from "@/util/remove_all"
import { QUIZTYPE } from "@/consts/answer_column";


// NFR-5442 前回の学習履歴を再加工する。
export function createLatestQuestionHistories() {
    const workStore = useWorkStore()
    const selectedWork = workStore.selectedWork
    const selectedWorkIndex = workStore.selectedWorkIndex
    const isKeyboard = selectedWork[selectedWorkIndex]?.subject_field === '理科' || selectedWork[selectedWorkIndex]?.subject_field === '数学'
    // deepcopy of initialanswer to make local question_history
    let latestQuestionHistories: Array<any> = JSON.parse(JSON.stringify(workStore.initialAnswer))
    latestQuestionHistories = latestQuestionHistories.filter(answer => 
        workStore.questionIds.includes(answer.question_id) // question_idが含まれているか確認
    );
    let questionCorrectWrongList: Array<any> = []
    let question_ids: Array<number> = []
    let i: number = 0
    // store latestQuestionHistories with question_id as key and question_history as value
    let latestQuestionHistoriesDict = {}
    JSON.parse(JSON.stringify(workStore.latestQuestionHistories)).forEach(qh => latestQuestionHistoriesDict[qh.question_id] = qh)
    // iterate initialAnswer deepcopy part to set latest questioHistory
    for (let question of latestQuestionHistories) {
        // collect all question_ids
        question_ids.push(question.question_id)
        // fetch QuestionHistory according to question_id
        let item = latestQuestionHistoriesDict[question.question_id]
        // check if questionHistory deleted or not
        if (item) {
            questionCorrectWrongList.push({ result: item.is_correct_answer, progress: 1 })
            // store QuizHistory with quiz_id as key and quiz_history as value
            let quizHistoriesDict = {}
            item.quiz_histories.forEach(q => quizHistoriesDict[q.quiz_id] = q)
            // iterate quiz_histories to set latest quiz_history
            for (let j in question.quiz_histories) {
                let quizHistory = quizHistoriesDict[question.quiz_histories[j].quiz_id]
                // check if QuizHistory is deleted
                if (quizHistory) {
                    // check quiz type is written_random_order or other
                    if (workStore.questions[i].quizzes[j].answer_format == QUIZTYPE.WRITTEN_RANDOM_ORDER) {
                        // separate answer to know how many random quizzes
                        let quizzes_history: Array<any> = quizHistory.answer.split("、")
                        // if quiz_history is correct that means all random quiz is correct and set it
                        if (quizHistory.is_correct_answer) {
                            question.quiz_histories[j]["sub_quizzes"] = quizzes_history.map(q => {
                                return { answer: q, is_correct_answer: true }
                            })
                        } else {
                            // any of quiz is false then find which one if false/true and set it
                            // deepcopy of original answer to compare with user_answer for find true/false answer
                            let answers: Array<any> = JSON.parse(JSON.stringify(workStore.questions[i].quizzes[j].body.answersList))
                            // remove all ruby and latexConversion
                            for (let answer of answers) {
                                for (let k = 0; k < answer.length; k++) {
                                    answer[k] = isKeyboard ? convertLatex(answer[k]) : answer[k]; // 変換された値を元の配列に代入
                                }
                            }
                            // quizzes_historyが[""]の場合(何も入力してない場合)、answersの配列数と同じ空の配列に変更
                            if (quizzes_history.length === 1 && quizzes_history[0] === "") {
                                quizzes_history = new Array(answers.length).fill(""); // 空の配列を作成
                            }
                            question.quiz_histories[j]["sub_quizzes"] = []
                            for (let quiz_history of quizzes_history) {
                                // check if user quiz_history answer is empty or not
                                if (quiz_history) {
                                    let con_text = isKeyboard ? convertLatex(quiz_history) : quiz_history
                                    let is_correct = false
                                    // match the user answer to original answer if found then delete answer form original
                                    for (let k = 0; k < answers.length; k++) {
                                        if (answers[k].includes(con_text)) {
                                            is_correct = true
                                            answers.splice(k, 1)
                                            break
                                        }
                                    }
                                    if (is_correct) {
                                        question.quiz_histories[j]["sub_quizzes"].push({ answer: quiz_history, is_correct_answer: true })
                                    }
                                    else {
                                        // NFR-5442 間違えた問題だけ再チャレンジを解く時は誤答は復元しない。
                                        if(workStore.isWronglyAnswered){
                                            question.quiz_histories[j]["sub_quizzes"].push({ answer: "", is_correct_answer: false })
                                        }else{
                                            question.quiz_histories[j]["sub_quizzes"].push({ answer: quiz_history, is_correct_answer: false })
                                        }
                                        
                                    }
                                } else {
                                    // user did not answer this quiz and set it false
                                    question.quiz_histories[j]["sub_quizzes"].push({ answer: quiz_history, is_correct_answer: false })
                                }
                            }
                        }
                    } else {
                        // NFR-5442 間違えた問題だけ再チャレンジを解く時は誤答は復元しない。
                        if(workStore.isWronglyAnswered){
                            if(!quizHistory.is_correct_answer){
                                quizHistory.answer = ""
                                question.quiz_histories[j] = quizHistory
                            }else{
                                question.quiz_histories[j] = quizHistory
                            }
                        }else{
                            // modify initial quiz_histories to lates quizHistory
                            question.quiz_histories[j] = quizHistory
                        }
                    }
                } else {
                    // QuizHistory is deleted and add extra flag is_deleted to know this quiz history is deleted for db
                    let quiz_history = question.quiz_histories[j]
                    if (quiz_history["sub_quizzes"]) {
                        for (let sub_quiz of quiz_history["sub_quizzes"]) {
                            sub_quiz["is_deleted"] = true
                        }
                    } else {
                        quiz_history["is_deleted"] = true
                    }
                }
            }
            question.is_correct_answer = item.is_correct_answer
        } else {
            // add deleted question histories and extra flag is_deleted to identify this question all quizzes history is deleted from db
            questionCorrectWrongList.push({ result: false, progress: 1 })
            for (let quiz_history of question.quiz_histories) {
                if (quiz_history["sub_quizzes"]) {
                    for (let sub_quiz of quiz_history["sub_quizzes"]) {
                        sub_quiz["is_deleted"] = true
                    }
                } else {
                    quiz_history["is_deleted"] = true
                }
            }
        }
        i++
    }
    if(workStore.isWronglyAnswered){
        latestQuestionHistories.forEach(answer => {
            answer.quiz_histories.forEach(quiz => {
                quiz.is_first_correct_answer = quiz.is_correct_answer;
            });
        });
    }
    workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
    workStore.fetchQuestionProgress({ question_ids: question_ids })
    // save the modified initialAnswer
    workStore.saveInitializeAnswer(latestQuestionHistories)
    return questionCorrectWrongList;
}


